import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from '@environments/environment';

export interface BizdevLookupItem {
    id?: number;
    category: string;
    label: string;
    value: string;
    sortOrder?: number;
    active?: boolean;
}

@Injectable({ providedIn: 'root' })
export class BizdevLookupService {

    private cache = new Map<string, Observable<BizdevLookupItem[]>>();
    private baseUrl = `${environment.apiUrl}/bizdev-lookups`;

    constructor(private http: HttpClient) {}

    getByCategory(category: string): Observable<BizdevLookupItem[]> {
        if (!this.cache.has(category)) {
            const req = this.http.get<any>(`${this.baseUrl}?category=${category}`).pipe(
                map((res: any) => res?.data?.lookups || []),
                catchError(() => of([])),
                shareReplay(1)
            );
            this.cache.set(category, req);
        }
        return this.cache.get(category);
    }

    save(item: BizdevLookupItem): Observable<any> {
        this.cache.clear();
        return this.http.post<any>(this.baseUrl, item);
    }

    delete(id: number): Observable<any> {
        this.cache.clear();
        return this.http.delete<any>(`${this.baseUrl}/${id}`);
    }
}
